import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[onlyNumber]'
})
// tslint:disable-next-line:directive-class-suffix
export class OnlyNumber {

  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl
  ) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const e = event;
    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A / Cmd+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C / Cmd+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X / Cmd+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V / Cmd+V (Paste)
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+Z / Cmd+Z (Undo)
      (e.keyCode === 90 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right, up, down
      (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text') || '';
    const cleanText = pastedText.replace(/[^0-9]*/g, '');

    const inputEl = this.el.nativeElement;
    const start = inputEl.selectionStart !== null ? inputEl.selectionStart : inputEl.value.length;
    const end = inputEl.selectionEnd !== null ? inputEl.selectionEnd : inputEl.value.length;
    const currentValue = inputEl.value || '';

    const newRawValue = currentValue.slice(0, start) + cleanText + currentValue.slice(end);

    const maxLen = inputEl.getAttribute('maxlength');
    let finalVal = newRawValue;
    if (maxLen && !isNaN(Number(maxLen)) && Number(maxLen) > 0) {
      finalVal = newRawValue.slice(0, Number(maxLen));
    }

    event.preventDefault();
    this.updateValue(finalVal);
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value || '';
    let cleanValue = initialValue.replace(/[^0-9]*/g, '');

    const maxLen = this.el.nativeElement.getAttribute('maxlength');
    if (maxLen && !isNaN(Number(maxLen)) && Number(maxLen) > 0) {
      cleanValue = cleanValue.slice(0, Number(maxLen));
    }

    if (initialValue !== cleanValue) {
      this.updateValue(cleanValue);
    }
  }

  private updateValue(value: string): void {
    this.el.nativeElement.value = value;
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(value);
      this.ngControl.control.markAsDirty();
      this.ngControl.control.markAsTouched();
    } else {
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
